import axios from "axios";
import api from "@/api";

const state = {
    key: "",
    url: "",
};

const getters = {
    key(state) {
        return state.key;
    },
    url(state) {
        return state.url;
    },
};

const actions = {
    upload({ commit }, { payload: { elementType, file } }) {
        return api
            .post(`/api/learning/storage/s3/upload/${elementType}`, {
                file: { name: file.name, type: file.type },
            })
            .then(res => {
                commit("update", { key: "key", value: res.data.key });

                // We are using axios here so that we are not sending the JWT to AWS
                //
                return axios.put(res.data.url, file);
            });
    },
    download({ commit }, { payload: { key, mimetype } }) {
        return api.post("/api/learning/storage/s3/download", { key, mimetype }).then(res => {
            commit("update", { key: "url", value: res.data.url });
        });
    },
    clear({ commit }) {
        commit("update", { key: "key", value: null });
        commit("update", { key: "url", value: null });
    },
};

const mutations = {
    update(state, { key, value }) {
        state[key] = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
